import { Rate } from "antd";
import dayjs from "dayjs";
import CommonImages from "@base/assets/images";
import { IDoctorRating } from "@base/modules/doctor/interface/doctor.interface";
import themeColor from "@base/themes/colorTheme";

interface IProps {
  rating: IDoctorRating;
  /** Clamp the comment to three lines, for the strip on the profile. */
  compact?: boolean;
  onClick?: () => void;
}

/** One patient's rating. Patients have no photo here, so the avatar is always the default. */
export default function RatingCard({ rating, compact, onClick }: IProps) {
  const content = (
    <>
      <div className="flex items-start gap-3">
        <img className="flex-none w-10 h-10 rounded-full border border-common-divider" src={CommonImages.DefaultAvatar} alt="" />

        <div className="grow min-w-0 flex flex-col gap-0.5">
          <div className="flex items-baseline justify-between gap-3">
            <span className="text-sm lg:text-base font-medium font-['Inter'] text-common-maintext line-clamp-1">
              {rating.patient_record?.patient_name}
            </span>
            {rating.rating_date ? (
              <span className="flex-none text-xs font-['Inter'] text-common-subtext">{dayjs(rating.rating_date).format("DD/MM/YYYY")}</span>
            ) : null}
          </div>
          <Rate disabled value={rating.point ?? 0} style={{ fontSize: 14, color: themeColor.yellow500 }} className="[&_.ant-rate-star]:!me-1" />
        </div>
      </div>

      {rating.comment ? (
        <p className={`m-0 whitespace-pre-line break-words text-sm font-['Inter'] text-common-subtext ${compact ? "line-clamp-3" : ""}`}>
          {rating.comment}
        </p>
      ) : null}
    </>
  );

  const className = "w-full h-full flex flex-col gap-3 p-4 rounded-xl border border-common-divider bg-common-white text-left";

  if (!onClick) {
    return <div className={className}>{content}</div>;
  }

  return (
    <button type="button" onClick={onClick} className={`${className} cursor-pointer hover:border-common-primary300 transition-colors`}>
      {content}
    </button>
  );
}
